import { Button, withStyles } from '@material-ui/core';

import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const ModelSecondaryButton = withStyles({
  root: {
    color: getColorTheme('secondaryButtonText'), // Secondary button color font
  },
  label: {
    '&$disabled': {
      color: getColorTheme('secondaryButtonDisabled') + ' !important',
    },
  },
})(Button);
